module.exports = __webpack_public_path__ + "static/img/laptop-and-cellohone-combined.934ee7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/laptop-and-cellohone-combined.png
// module id = BN3U
// module chunks = 1